export default {
    SERVER_BASE_URL: 'http://localhost:3000/',
    PHONE_EXT:'+1',
    ENV: 'development',
    CLIENT_URL: 'http://localhost:8080/',
    OPTIMIZELY_KEY: 'WFHQHSxhfWTwBraRL7QoC',
}
